<template>
    <div class="container" v-if="ListGarantidorasGeral!=''">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading"><h3 class="fw-bold">Contratações em andamento</h3><ul class="breadcrumbs"><li class="nav-home"><router-link to="/home"><i class="fa fa-home"></i></router-link></li><li class="separator"><i class="fa fa-chevron-right"></i></li><li class="nav-item">Contratações</li><li class="separator"><i class="fa fa-chevron-right"></i></li><li class="nav-item">Em andamento</li></ul></div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Contratações Garantia Locatícia</h4>
                                    <router-link class="btn btn-sm btn-secondary ms-auto" to="/novacontratacao"><i class="fa fa-plus"></i> Nova contratação</router-link>
                                </div>
                            </div>
                            <div class="card-body">
                              <div class="gp-contract-status-toolbar">
                                    <button type="button"
                                        v-for="opt in situacoesMenu"
                                        :key="opt.id"
                                        class="gp-contract-status-button"
                                        :class="{ 'is-active': situacaoSelecionada === opt.id }"
                                        @click="SelecionaSituacao(opt.id)"
                                    >
                                        {{ opt.label }}
                                    </button>
                                    </div>
                                <v-row>
                                </v-row>
                                <adm-data-table :headers="gridHeaders" :export-headers="headers" :filter-source-headers="filterHeaders"
                                    :filter-columns="4" :items="ListPedidosGeralFiltro"
                                    total-field="pedValorTotalPedido" total-label="Valor total filtrado"
                                    v-model="itemsSelected" alternating theme-color="#364f66"
                                    table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina" file-name="contratacoes-em-andamento"
>
                                    <template #item-entidadesResumo="item"><div class="gp-contract-entity-summary"><strong>{{ item.garNome || '—' }}</strong><small>{{ item.imobNome || '—' }}</small></div></template>
                                    <template #item-clienteResumo="item"><div class="gp-contract-client-summary"><strong>{{ item.cliNome || '—' }}</strong><small>{{ item.cliDocumento || '—' }}</small></div>
                                    </template>
                                    <template #item-pedDataPedido="item">
                                        <span> {{ item.pedDataPedido !== null ? formattedDate(item.pedDataPedido) : null }}</span>
                                    </template>
                                    <template #item-pedValorTotalPedido="item">
                                        {{ item.pedValorTotalPedido !== null ? formatarValor(item.pedValorTotalPedido) : 0 }}
                                    </template>
                                    <template #item-pedSituacaoPedido="item">
                                        <span class="gp-contract-status-badge" :class="`status-${item.pspId}`">{{ item.pedSituacaoPedido }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <div class="gp-table-actions"><button type="button" class="gp-table-action gp-action-edit" title="Abrir contratação" @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button></div>
                                    </template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'

export default {
    name: 'ListaContratacoesView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
         User: {
            garid:0,
            tpeid:0,
        },
        searchValue: '',
        NomeTela:'Contratações',
        InfoTela:'Lista de Contratações',
        MostraGrid: true,
        headers: [],
        Idiomas:[],
        vshowidioma: true,
        CadastroTelas:[{ cdtId: 28, cdtNome: "Lista Contratações" }],
        Pedidos:[],
        ListPedidosGeral:[],
        ListPedidosGeralFiltro:[],
        ListGarantidorasGeral:[],
        DadosCompra: [],
        situacaoSelecionada: 0,
         situacoesMenu: [          
            { id: 2, label: "Análise Manual" },
            { id: 8, label: "Aguardando Documentos" },
            { id: 14, label: "Processando Análise de Crédito" },
            { id: 15, label: "Gerar Contrato" },
            { id: 13, label: "Preparando Envio Assinatura" },
            { id: 9, label: "Aguardando Assinatura" },
            { id: 5, label: "Aprovado Gerar Cobrança" },
            { id: 7, label: "Aguardando Pagamento" },
            { id: 0, label: "Todos" },
            ]
    }),
    computed: {
        filterHeaders() {
            const camposOcultos = ['pedDataPedido', 'pedValorTotalPedido', 'pedSituacaoPedido'];
            return this.headers.filter(header => !camposOcultos.includes(header.value));
        },
        gridHeaders() {
            const resultado=[];let entidades=false;let cliente=false;
            this.headers.forEach(header=>{if(header.value==='garNome'||header.value==='imobNome'){if(!entidades){resultado.push({text:'Garantidora / Imobiliária',value:'entidadesResumo',sortable:false});entidades=true}}else if(header.value==='cliNome'||header.value==='cliDocumento'){if(!cliente){resultado.push({text:'Cliente / Documento',value:'clienteResumo',sortable:false});cliente=true}}else resultado.push(header)});
            return resultado;
        }
    },
    methods: {
        statusClass(pspId) {
            const map = {
            8:  "btn-warning",     // mantém (warning)
            9:  "btn-dark",        // mantém (black)
            7:  "btn-info",
            2:  "btn-secondary",
            1:  "btn-primary",
            5:  "btn-orange",      // custom
            13: "btn-purple",      // custom
            14: "btn-teal",        // custom
            15: "btn-pink"         // custom
            };

            return map[pspId] || "btn-light";
        },
        SelecionaSituacao(value){
            this.situacaoSelecionada = value;
            if (value > 0){          
                this.ListPedidosGeralFiltro = this.ListPedidosGeral.filter(x=> x.pspId == value);
            }
            else{
                this.ListPedidosGeralFiltro = this.ListPedidosGeral;
            }
          
        },
        onReady(editor)  {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        preprocessData(data) {
            return data.map(item => {
            return {
                ...item,
                proOrdem: parseInt(item.proOrdem),
            };
            });
        },
        formattedDate(value) {
            if (value!=null || value != ""){
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else{
                return "";
            }
           
        },
        formatarValor(valor) {
            return Number(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        EditGrid(item) {
           this.$router.push('/contratacaodetalhe/' + encodeURIComponent(item.pedToken || item.pedId));
        },
        montaGrid(){
            this.headers=[];
            this.headers.push({ text: "Id", value: "pedId", sortable: true, });
            this.headers.push({ text: "Data", value: "pedDataPedido", sortable: true, });
            if (this.User.garid == 0){
                this.headers.push({ text: "Garantidora", value: "garNome", sortable: true, });
            }
            if (this.User.tpeid != 3){
            this.headers.push({ text: "Imobiliaria", value: "imobNome", sortable: true, });
            }
            this.headers.push({ text: "Cliente", value: "cliNome", sortable: true, });
            this.headers.push({ text: "Documento", value: "cliDocumento", sortable: true, });
            this.headers.push({ text: "Valor", value: "pedValorTotalPedido", sortable: true, });
            this.headers.push({ text: "Situação", value: "pedSituacaoPedido", sortable: true, });
            this.headers.push({ text: 'Ações', value: 'actions' });
        },
        async Get() {
              await axios.get(`/Telas/ContratacoesAndamento/GetDados`)
                .then(response => {
                    const todasGarantidoras = response.data.garantidoras || [];
                    this.ListGarantidorasGeral = todasGarantidoras.filter(x => x.garVisivel).sort((a, b) =>
                        a.garNomeEmpresa.localeCompare(
                            b.garNomeEmpresa,
                            'pt',
                            { sensitivity: 'base' }
                        )
                    );

                    this.User.garid = response.data.garId;
                    this.User.tpeid = response.data.tpeId;

                    const garantidorasPorId = new Map(todasGarantidoras.map(item => [String(item.garId), item.garNomeEmpresa]));
                    this.ListPedidosGeral = (response.data.pedidos || [])
                        .filter(item => Number(item.pspId) !== 1)
                        .map(item => ({ ...item, garNome: garantidorasPorId.get(String(item.garId)) || '' }));
                    this.ListPedidosGeralFiltro = this.ListPedidosGeral.sort((a, b) => {
                                                                        const valorA = parseInt(a.pedId) || 0;
                                                                        const valorB = parseInt(b.pedId) || 0;
                                                                        return valorA - valorB;
                                                                    }).reverse();
                    this.montaGrid();
                });           
          
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style scoped>
  .tabinfo{
    font-size:14px;
    text-transform: capitalize;
  }


.gp-contract-status-toolbar{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:14px;padding-bottom:12px;border-bottom:1px solid #e8e1d7}.gp-contract-status-button{min-height:34px;padding:6px 12px;border:1px solid #d8d2c8;border-radius:9px;background:#fff;color:#596579;font-size:11px;font-weight:700;transition:.18s ease}.gp-contract-status-button:hover{border-color:#e77900;color:#c96500}.gp-contract-status-button.is-active{border-color:#e77900;background:#e77900;color:#fff;box-shadow:0 4px 10px rgba(231,121,0,.18)}
.gp-contract-entity-summary,.gp-contract-client-summary{display:flex;max-width:235px;flex-direction:column;gap:2px;line-height:1.25;white-space:normal;word-break:break-word}.gp-contract-entity-summary strong,.gp-contract-client-summary strong{color:#17223b;font-size:10.5px}.gp-contract-entity-summary small,.gp-contract-client-summary small{color:#718096;font-size:9.5px}.gp-contract-status-badge{display:inline-flex;align-items:center;justify-content:center;max-width:150px;min-height:22px;padding:3px 8px;border-radius:999px;background:#eef1f5;color:#596579;font-size:8.5px;font-weight:800;line-height:1.2;text-align:center;white-space:normal}.gp-contract-status-badge.status-1{background:#e8eef9;color:#1d4f9f}.gp-contract-status-badge.status-2{background:#f0edf8;color:#66508e}.gp-contract-status-badge.status-8{background:#fff0dd;color:#a95700}.gp-contract-status-badge.status-14{background:#e7f7f1;color:#157052}.gp-contract-status-badge.status-15{background:#fdeaf1;color:#a63765}.gp-contract-status-badge.status-13{background:#f0eafa;color:#7046a0}.gp-contract-status-badge.status-9{background:#e9edf3;color:#354158}.gp-contract-status-badge.status-5{background:#fff0dd;color:#a95700}.gp-contract-status-badge.status-7{background:#e7f4ff;color:#216a9b}
@media(max-width:767.98px){.gp-contract-status-toolbar{display:grid;grid-template-columns:repeat(2,minmax(0,1fr))}.gp-contract-status-button{width:100%}}

</style>
